import React from 'react';
import ItemLocationList from './ItemLocationList';

const ItemLocationCurrentMachine = () => {
  return <ItemLocationList isCurrentMachine />;
};

export default ItemLocationCurrentMachine;
